import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../environments/environment.prod';
const TOKEN_HEADER_KEY = 'Authorization';
export const TokenBearerInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem(environment.auth_token_key);
  if (token) {
    return next(
      req.clone({
        headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token),
      })
    );
  }
  return next(req);
};
